const baseUrl = process.env.NODE_ENV === 'production'
                ? 'https://priority-api-gac-production.up.railway.app'
                : 'https://priority-api-gac-production.up.railway.app'

export default baseUrl;